/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupDto as DigiworkMaitreDPosDtoGroupGroupDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Group/group-dto';

export interface GetGroup$Params {
  servingAreaId: string;
}

export function getGroup(http: HttpClient, rootUrl: string, params: GetGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>> {
  const rb = new RequestBuilder(rootUrl, getGroup.PATH, 'get');
  if (params) {
    rb.path('servingAreaId', params.servingAreaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>;
    })
  );
}

getGroup.PATH = '/api/groups/{servingAreaId}';
